import React from 'react';
import './cityDigitalTwinBook.css';
import Footer from '../Footer';
// Using existing images from the project
const heroBg = process.env.PUBLIC_URL + "/images/hero-bg-dt.png";

function CityDigitalTwinBook() {

  const people = [
    { name: 'Dr. Zoltan Nagy', initials: 'ZN', image: 'zoltan.jpg' },
    { name: 'Dr. Dru Crawley', initials: 'DC', image: 'dru.jpg' },
    { name: 'Dr. Dev Niyogi', initials: 'DN', image: 'Dev.png' },
    { name: 'Jocelyn Rodriguez', initials: 'JR', image: 'jocelynr.jpeg' },
  ];

  // Hero background styling - you can control these properties
  const heroStyle = {
    backgroundImage: `linear-gradient(to top right, rgba(10, 9, 6, 0.88), rgba(10, 9, 6, 0.5) 46%, rgba(10, 9, 6, 0.2)), url(${heroBg})`,
    backgroundSize: 'cover', // Options: 'cover', 'contain', 'auto', '100% 100%'
    backgroundPosition: 'center', // Options: 'center', 'top', 'bottom', 'left', 'right', 'top left', etc.
    backgroundRepeat: 'no-repeat', // Options: 'no-repeat', 'repeat', 'repeat-x', 'repeat-y'
    backgroundAttachment: 'scroll' // Options: 'scroll', 'fixed', 'local'
  };

  return (
    <>
    <div className="city-digital-twin-book">
      {/* Hero Section - Full Width */}
      <div className="city-dt-hero" style={heroStyle}>
        <div className="city-dt-title-container">
          <h1 className="city-dt-hero-title">City Digital Twin Book</h1>
          <div className="city-dt-subtitle-section">Authors' portal</div>
        </div>
      </div>

      {/* Main Content - Full Width */}
      <div className="city-dt-main-content">
        {/* Left Column */}
        <div className="city-dt-left-column">
          {/* Buttons */}
          <div className="city-dt-buttons">
            <a href="https://utexas.box.com/s/y99vhw19kjajaix5nucerq5p5gg6phc7" className="city-dt-button">Submission box link</a>
            <a 
              href="https://utexas.box.com/s/yt1klh558nbw0ctkgi7q7vo8v1x9goif"
              target="_blank"
              rel="noopener noreferrer"
              className="city-dt-button"
            >
              Info Session Recording
            </a>
            <a 
              href="https://utexas.box.com/s/we6r0rbnjm1to5ov0m92vmihvyz6s35j"
              target="_blank"
              rel="noopener noreferrer"
              className="city-dt-button"
            >
              Info Session 2
            </a>
            {/* <a href="https://utexas.box.com/s/59av7t5c9lrhaeycbtyl4p6iuprx6egg" className="city-dt-button">FAQs link</a> */}
          </div>

          {/* People Section */}
          <div className="city-dt-people-section">
            <h2 className="city-dt-section-title">People</h2>
            <div className="city-dt-people-grid">
              {people.map((person, index) => (
                <div key={index} className="city-dt-person">
                  <div className="city-dt-avatar">
                    {person.image ? (
                      <img 
                        src={process.env.PUBLIC_URL + "/images/" + person.image} 
                        alt={person.name}
                        className="city-dt-avatar-img"
                      />
                    ) : (
                      person.initials
                    )}
                  </div>
                  <div className="city-dt-person-name">{person.name}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Logo Section */}
          <div className="city-dt-logo-section">
            <div className="city-dt-logo">
              <img src={process.env.PUBLIC_URL + "/images/bentley_logo.png"} alt="Bentley Logo" />
            </div>
            <div className="city-dt-logo">
              <img src={process.env.PUBLIC_URL + "/images/texus_logo_1.svg"} alt="Texus Logo" />
            </div>
          </div>
        </div>

        {/* Right Column */}
        <div className="city-dt-right-column">
          {/* Digital Twin Book Image */}
          <div className="city-dt-book-image-container">
            <img 
              src={process.env.PUBLIC_URL + "/images/bg-dt.png"} 
              alt="City Digital Twin Book" 
              className="city-dt-book-image"
            />
          </div>
          
          {/* <div className="city-dt-video-grid">
            {videos.map((video, index) => (
              <a key={index} href="#" className="city-dt-video-card">
                <img src={playIcon} alt="" className="city-dt-play-icon" />
                <div className="city-dt-video-title">{video.name}</div>
              </a>
            ))}
          </div> */}
        </div>
      </div>

    </div>

      <Footer />
    </>
  );
}

export default CityDigitalTwinBook;